const ENDPOINT = process.env.REACT_APP_ENDPOINT
const CDN_ENDPOINT = process.env.REACT_APP_CDN_ENDPOINT || '/'
export const API_ENDPOINT = `${ENDPOINT}api`
export const AUTH_ENDPOINT = `${ENDPOINT}auth`
export const GPX_ENDPOINT = `${CDN_ENDPOINT}gpx`
